var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"table",attrs:{"paging":"","columns":_vm.columns,"rows":_vm.rows,"selection":"","height":_vm.height,"pageUnit":_vm.searchPopupMPagingInfo.pageUnit,"totalSize":_vm.searchPopupMPagingInfo.totalSize},on:{"changedPage":_vm.changedPage},scopedSlots:_vm._u([{key:"actionsLeft",fn:function(){return undefined},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }